module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal__content modal__content--project-team pl0 pr0 pt30 pb20"
  }, [_c('div', {
    staticClass: "border-bottom-lightest2 pl30 pr30 mb30"
  }, [_c('h5', {
    staticClass: "text-size-11 text-space-12 text-color-gray-dark text-medium text-uppercase pt2 mb5"
  }, [_vm._v("add your team members")]), _vm._v(" "), _c('form', {
    staticClass: "flex-nowrap flex--align-vertical mb15",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onConfirm($event)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }, {
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.userInvite.email),
      expression: "userInvite.email",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control form-control--small mr10",
    class: {
      'has-error': _vm.errors.has('email')
    },
    attrs: {
      "type": "text",
      "name": "email",
      "id": "email",
      "placeholder": "name@email.com"
    },
    domProps: {
      "value": (_vm.userInvite.email)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.userInvite, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userInvite.selectedRole),
      expression: "userInvite.selectedRole"
    }],
    staticClass: "form-control form-control--small mr10",
    attrs: {
      "name": "user-role",
      "id": "user-role"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.userInvite, "selectedRole", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.userRoles), function(option) {
    return _c('option', {
      key: option.name,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.name))])
  }), 0), _vm._v(" "), _c('button', {
    staticClass: "btn btn--plus-green"
  }, [_vm._v("+")])]), _vm._v(" "), (_vm.userInvite.selectedRole === 'editor') ? _c('p', {
    staticClass: "text-size-15 text-medium text-height-14 mb25"
  }, [_vm._v("Editor can view tasks, add new tasks, write comments, see task costs"), _c('br', {
    staticClass: "hidden-xs-down"
  }), _vm._v(" and see project balance. Can not top up the balance.")]) : _vm._e(), _vm._v(" "), (_vm.userInvite.selectedRole === 'viewer') ? _c('p', {
    staticClass: "text-size-15 text-medium text-height-14 mb25"
  }, [_vm._v("Viewer can view tasks, add new tasks and write comments. Can not"), _c('br', {
    staticClass: "hidden-xs-down"
  }), _vm._v(" see task costs, see project balance, top up the balance.")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "pl30 pr30"
  }, [_c('h5', {
    staticClass: "text-size-11 text-space-12 text-color-gray-dark text-medium text-uppercase"
  }, [_vm._v("current members")]), _vm._v(" "), _c('ul', {
    staticClass: "project-users-list"
  }, _vm._l((_vm.args.projectUsers), function(projectUser) {
    return _c('li', {
      key: projectUser.id,
      staticClass: "flex flex--justify-space-between border-bottom-lightest2 mb10 pb15 pt1"
    }, [_c('div', {
      staticClass: "flex flex--align-vertical project-users-list__avatar mr10 pr15"
    }, [(projectUser.avatarKey) ? _c('img', {
      staticClass: "img-circle img-circle--40 mr10",
      attrs: {
        "src": '/serve/s/' + projectUser.avatarKey + '?w=80&h=80',
        "alt": "User Avatar"
      }
    }) : _c('div', {
      staticClass: "img-circle img-circle--40 mr10 flex-nowrap flex--align-vertical"
    }, [_c('span', {
      staticClass: "text-color-white text-uppercase text-size-16 text-lh-1 text-center"
    }, [_vm._v("\n              " + _vm._s(_vm._f("firstCharacter")(projectUser.name)) + _vm._s(_vm._f("firstCharacter")(projectUser.surname)) + "\n            ")])]), _vm._v(" "), _c('div', {
      staticClass: "pt5"
    }, [_c('h5', {
      staticClass: "text-size-18 text-medium text-height-1 mb0 text-color-black pt2"
    }, [_vm._v(_vm._s(projectUser.name) + " " + _vm._s(_vm.userSurname(projectUser.surname)))]), _vm._v(" "), (_vm.checkUserRole(_vm.args.role, ['admin', 'projectManager']) || (_vm.checkUserRole(_vm.args.userProjectRole, ['owner', 'editor', 'viewer']) && _vm.checkUserRole(projectUser.userProjectRole, ['owner', 'editor', 'viewer', 'admin', 'projectManager']))) ? _c('a', {
      staticClass: "text-size-13 text-height-1",
      attrs: {
        "href": 'mailto:' + projectUser.email
      }
    }, [_vm._v(_vm._s(projectUser.email))]) : _vm._e()]), _vm._v(" "), (_vm.args.userId !== projectUser.id && (_vm.checkUserRole(_vm.args.role, ['admin', 'projectManager']) || _vm.checkUserRole(_vm.args.role, ['customer']) && _vm.checkUserRole(projectUser.userProjectRole, ['editor', 'viewer']))) ? _c('span', {
      staticClass: "remove icon-remove",
      on: {
        "click": function($event) {
          _vm.$bus.$emit('modalClose') && _vm.$bus.$emit('modalShow', ['project-remove-user-modal', {
            id: projectUser.id,
            name: projectUser.name
          }])
        }
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "flex flex--align-vertical w-100 w-auto-sm"
    }, [_c('h5', {
      staticClass: "text-medium mb0 ml20-sm text-color-dark-3"
    }, [_vm._v(_vm._s(projectUser.userProjectRoleText))])])])
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-28877270","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/project/modals/ProjectTeamModal.vue
// module id = 430
// module chunks = 2